import InterlibraryLoansApi from '../api/InterlibraryLoansApi';
import InterlibraryLoansConstants from '../constants/InterlibraryLoansConstants';

export function fetchInterlibraryLoans(query) {
  return {
    types: [
      InterlibraryLoansConstants.FETCH_ILL_REQUEST,
      InterlibraryLoansConstants.FETCH_ILL_SUCCESS,
      InterlibraryLoansConstants.FETCH_ILL_FAILURE
    ],
    middlewareData: {
      accountRequired: true
    },
    apiRequest: (state, apiClient) =>
      InterlibraryLoansApi.getInterlibraryLoans(apiClient, query)
  };
}

export default {
  fetchInterlibraryLoans
};



// WEBPACK FOOTER //
// ./app/actions/InterlibraryLoansActions.js